/* eslint-disable no-console */
import {
    CompressedStorageClient,
    getExternalAssessmentIndexedDBClient,
} from '@amplify/web-assessment-common/dist/storage';
import AssessmentStorageClient from './AssessmentStorageClient';

class Idel2OfflineStorage extends AssessmentStorageClient {
    /**
     * Initialize internal data source clients.
     * Takes clients that represent asynchronous and synchronous storages,
     * though both require to implement Storage API in order to be interchangeable.
     * @param {Boolean} [loggingEnabled=false] whether to post errors to console
     * @param {Storage} [storageAsync=indexedDB client] instance of client that implements Storage API
     * @param {Storage} [storageSync=localStorage] instance of client that implements Storage API
     */
    constructor(
        loggingEnabled,
        storageAsync = getExternalAssessmentIndexedDBClient(),
        storageSync = localStorage,
    ) {
        super(loggingEnabled, storageAsync, storageSync);
        this.goalsAndZoGClient = new CompressedStorageClient(storageAsync);
    }

    FORMS_KEY = 'idel2_forms';

    CUTSCORES_KEY = 'idel2_cutscores';

    OFFLINE_RESULTS_KEY = 'idel2_results';

    GOALS_KEY = 'idel2_student_goals';

    ZOG_KEY = 'idel2_student_growth_zones';

    FORMS_BLACKLIST_DETAILS_KEYS = [
        'assessment',
        'itemsMetadata',
        'lines',
        'maxScore',
        'totalLines',
        'version',
        'items',
        'paragraphs',
    ];

    CUTSCORES_OUTPUT_KEYS_MAP = {
        preliminaryGoalScore: 'goal',
    };

    // eslint-disable-next-line class-methods-use-this
    getStudentResultsKey(studentId) {
        return `idel2_student_${studentId}_results_compressed`;
    }

    /**
     * Get goals from storage.
     * @returns {Promise<Array>} list of goals: [<goal object 1> ...<goal object N>]
     */
    async getGoals() {
        try {
            return await this.goalsAndZoGClient.getItem(this.GOALS_KEY);
        } catch (e) {
            if (this.loggingEnabled) {
                console.warn(e);
            }
            return [];
        }
    }

    /**
     * Get growth zones from storage.
     * @returns {Promise<Array>} list of growth zones: [<growthZone object 1> ...<growthZone object N>]
     */
    async getZoG() {
        try {
            return await this.goalsAndZoGClient.getItem(this.ZOG_KEY);
        } catch (e) {
            if (this.loggingEnabled) {
                console.warn(e);
            }
            return [];
        }
    }
}

export default Idel2OfflineStorage;
